import { PropertyTypes } from "../../../../enums/PropertyTypes";
import { ISchema, ISchemaFilter, ISchemaProperty } from "../Schema";
import { FilterMatchType } from "../../../../enums/FilterMatchType";
import { FilterTypes } from "../../../../enums/FilterTypes";
import { RelatedFilterValidation } from "../../../../enums/RelatedFilterValidation";
import SidePanelPartFullOuterCube from "../../layout/SidePanel/layouts/SidePanelPartFullOuterCube";
import { EntityNames } from "../../../../enums/EntityNames";

export const PartFullOuterCubesSchema: ISchema = {
    displayName: "Part Full Outer Cubes",
    GetSidePanelComponent: (data, onViewPage) => <SidePanelPartFullOuterCube data={data} onViewPage={onViewPage} />,
    props: [
        {
            name: 'id',
            type: PropertyTypes.string,
            key: true
        } as ISchemaProperty,
        {
            name: 'reference',
            displayName: 'Reference',
            descriptor: true,
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'belongsTo',
            displayName: 'Belongs To',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'type',
            displayName: 'Type',
            type: PropertyTypes.string,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty,
        {
            name: 'percentageFull',
            displayName: 'Percentage Full',
            type: PropertyTypes.percentage,
            key: false,
            showInList: true,
            showInForm: false,
            showInView: false,
            requiredInForm: false,
        } as ISchemaProperty
    ],

    primaryFilter: {
        PropertyName: "Name",
        displayName: "Search",
        type: FilterTypes.search,
        required: false,
        className: "width--full",
        matchType: FilterMatchType.Equal,
        propertyType: PropertyTypes.string,
        placeHolder: "Enter an OC reference"
    } as ISchemaFilter,

    filters: [
        {
            PropertyName: "BelongsToCellTrak",
            displayName: "Belongs to CellTrak",
            type: FilterTypes.toggle,
            showInTab: true,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.belongsToCellTrak,
            onValue: true,
            offValue: undefined
        } as ISchemaFilter,
        {
            PropertyName: "Owner.AccountId",
            entityName: "accounts",
            displayName: "Account",
            type: FilterTypes.select,
            showInTab: true,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.uuid,
            relatedFilter: "BelongsToCellTrak",
            relatedFilterValidation: RelatedFilterValidation.MustNotHaveValue
        } as ISchemaFilter,
        {
            PropertyName: "Type",
            entityName: EntityNames.outerCubeTypes,
            displayName: "Type",
            type: FilterTypes.select,
            showInTab: true,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.int
        } as ISchemaFilter,
        {
            PropertyName: "PercentageFree",
            entityName: EntityNames.partFullOuterCubes,
            displayName: "Percentage Free",
            type: FilterTypes.select,
            showInTab: true,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.string
        } as ISchemaFilter,
        {
            PropertyName: "CaseMaterialTypeId",
            entityName: EntityNames.caseMaterialTypes,
            displayName: "Case Material Type",
            type: FilterTypes.select,
            showInTab: true,
            required: false,
            className: "small-4",
            matchType: FilterMatchType.Equal,
            propertyType: PropertyTypes.uuid
        } as ISchemaFilter
    ],

    children: []
}
